import { AxiosResponse } from 'axios';
import { FBaseService } from '@kasasa/fbase-components/lib';
import { CycleValidationSnapshot } from '@/types/cyclevalidationsnapshot';
import KrpTechopsAdminResource from '@/api/resource/KrpTechopsAdminResource';

export default class CycleValidationResource extends KrpTechopsAdminResource {
  public async getLatestApprovedCycleValidationSnapshot(fiId: number, cycleId: number):
    Promise<CycleValidationSnapshot> {
    const url = `/api/rcx/director/${fiId}/cycle-validation-snapshot?cycleId=${cycleId}&approvalState=APPROVED`;

    const response: AxiosResponse = await this.apiClient.get(url);

    return response.data.data;
  }
}
